import { ReportsValidationService } from './reports-validation.service';

export default angular
  .module('sfMobile.services.reports-validation', [])
  .factory('reportsValidationAPIService', ReportsValidationService).name;
